import { cn, Flex, Skeleton } from '@kognitos/lattice';

/** Widths of the body lines, so the page reads as text rather than stripes. */
const LINE_WIDTHS = ['w-full', 'w-11/12', 'w-4/5', 'w-5/6', 'w-2/3'];

/** Props for {@link IDPDocumentSkeleton}. */
interface IIDPDocumentSkeletonProps {
  /** Tighter spacing for a thumbnail-sized page */
  dense?: boolean;
  className?: string;
}

/**
 * A pulsing document page for wherever an IDP document is loading.
 *
 * @param props - Component props
 * @returns The page skeleton
 */
export function IDPDocumentSkeleton({
  dense = false,
  className,
}: IIDPDocumentSkeletonProps) {
  const line = dense ? 'h-1.5' : 'h-3';
  return (
    <Flex
      direction="column"
      gap={dense ? 1 : 3}
      padding={dense ? 2 : 6}
      className={cn('h-full w-full', className)}
      aria-busy="true"
      data-testid="idp-document-skeleton"
    >
      <Skeleton className={cn(dense ? 'h-2.5' : 'h-6', 'w-1/2')} />
      <Skeleton className={cn(line, 'w-1/3')} />
      <Skeleton className={cn(dense ? 'mt-1 h-6' : 'mt-3 h-24', 'w-full')} />
      {LINE_WIDTHS.map(width => (
        <Skeleton key={width} className={cn(line, width)} />
      ))}
    </Flex>
  );
}
